export default {
  zoomIn({ state, commit }) {
    const {
      svg: { parentObj, maxZoom, zoomFactor, currentZoom }
    } = state;

    const newZoom = Math.min(currentZoom + zoomFactor, maxZoom);

    parentObj.zoom(newZoom);
    const newViewbox = parentObj.viewbox();

    commit('setZoom', newZoom);
    commit('setVBox', newViewbox);
  },
  zoomOut({ state, commit }) {
    const {
      svg: { parentObj, minZoom, zoomFactor, currentZoom }
    } = state;

    const newZoom = Math.max(currentZoom - zoomFactor, minZoom);

    parentObj.zoom(newZoom);
    const newViewbox = parentObj.viewbox();

    commit('setZoom', newZoom);
    commit('setVBox', newViewbox);
  },
  resetMap({ state, commit }) {
    const {
      svg: { defaultVBox, parentObj }
    } = state;

    parentObj.viewbox(defaultVBox);
    commit('setVBox', defaultVBox);
    commit('setZoom', parentObj.zoom());
  }
};
